/* @flow */

import * as React from 'react';
import {TimesIcon} from '../../icon';
import styles from './cancel-button.css';

type Props = {
    className?: string,
    onClick: () => void,
};

export class CancelButton extends React.PureComponent<Props> {
    render() {
        const className = this.props.className
            ? `${this.props.className} ${styles.container}`
            : styles.container;

        return (
            <button onClick={this.props.onClick} className={className}>
                <TimesIcon />
            </button>
        );
    }
}
